export const getUserMessage = (_error: unknown, fallback: string): string => fallback;

export const logErrorInDevelopment = (message: string, error: unknown): void => {
  if (process.env.NODE_ENV === 'development') {
    console.error(message, error);
  }
};
